export const HOME_ROUTE_PATH = 'main'
export const LOGIN_ROUTE_PATH = 'login'
export const CUSTOMERS_ROUTE_PATH = 'customers'

/**
 * A list of colors to be used in various displays
 */
export const COLOR_LIST = [
  '#fedd46',
  '#00960a',
  '#7c9ed3',
  '#aa4586',
  '#a8763e',
  '#424874'
]